<template>
  <span>
    <input
      type="file"
      v-show="false"
      ref="file"
      @change="uploadAnexo()"
      accept="image/*"
    />
    <v-btn
      rounded
      small
      color="info"
      @click="$refs.file.click()"
      min-width="115"
    >
      <v-icon size="17" class="mr-1">mdi-upload</v-icon> Anexar
    </v-btn>
  </span>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  props: {
    anexo: Object,
  },
  methods: {
    ...mapMutations("anexos", ["addDoc"]),
    uploadAnexo() {      
      var data = {
        codigo: this.anexo.codigo,
        codanexo: this.anexo.codigo,
        file: this.$refs.file.files,
        obrigatorio: this.anexo.obrigatorio,
        alterar: this.anexo.alterar,
        incluir: this.anexo.incluir
      };
      this.addDoc(data);
    },
  },
};
</script>

<style>
</style>